import { SMART_REPLY_PROPERTY_NAME } from './constants';
import createSmartReplyPillData from './createSmartReplyPillData';
import getPropertyFromItem from './getPropertyFromItem';
import parseSmartReplyProperty from './parseSmartReplyProperty';
import { ClientItem } from 'owa-mail-store';
import ExtendedPropertyType from 'owa-service/lib/contract/ExtendedPropertyType';
import { SmartPillData } from 'owa-smart-pill';
import { GetItemManagerFeatureIds } from 'owa-mail-smart-pill-features';
import { trace } from 'owa-trace';
import { lazyGetItemProperties } from 'owa-get-item-manager';

export default async function getSmartRepliesForItem(item: ClientItem): Promise<SmartPillData[]> {
    if (item) {
        if (!item.SmartReplyData) {
            const getItemProperties = await lazyGetItemProperties.import();
            const itemWithProperty: ClientItem = (await getItemProperties(
                item.ItemId.Id,
                GetItemManagerFeatureIds.SmartReply
            )) as ClientItem;

            // At this point, if itemWithProperty exists, it should be the same as the item input into this function.
            if (itemWithProperty) {
                const extendedProperty: ExtendedPropertyType = getPropertyFromItem(
                    itemWithProperty,
                    SMART_REPLY_PROPERTY_NAME
                );

                parseSmartReplyProperty(itemWithProperty, extendedProperty);
            }
        }

        // Null check needed for testing
        if (item.SmartReplyData?.ExtractionID) {
            // Processed smart reply data is cached on item, just return it.
            return item.SmartReplyData.SmartReplies.map((smartReply, index) =>
                createSmartReplyPillData(
                    item,
                    smartReply,
                    item.SmartReplyData.LoggableSmartReplies[index],
                    item.SmartReplyData.ExtractionID,
                    index
                )
            );
        }
    } else {
        trace.info('[getSmartRepliesForItem] No item, cannot produce smart replies.');
    }

    return [];
}
